import { GithubIcon, GoogleIcon, SlackIcon } from '@sketchnote/icons';
import { useAuth } from 'src/shared/hooks/use-auth';

const appMetaData = {
  slack: {
    name: 'Slack',
    value: 'slack',
    type: 'Communication',
    description: 'Connect your Slack account to see your updates in real time',
    icon: <SlackIcon wrapperClass="pr-16 pt-6" size={40} />,
    linkText: 'View integrations →',
  },
  github: {
    name: 'GitHub',
    value: 'github',
    type: 'Software Development',
    description: 'Connect your GitHub account to track and create issues on your workspace',
    icon: <GithubIcon wrapperClass="pr-16 pt-6" size={40} />,
    linkText: 'Connect →',
  },
  googleCalendar: {
    name: 'Google Calendar',
    value: 'google',
    type: 'Productivity',
    description: 'Connect your calendar events and view them on Sketchnote',
    icon: <GoogleIcon wrapperClass="pr-16 pt-6" size={40} />,
    linkText: 'View connections →',
  },
};

export const Integrations = ({
  onClose,
  setActiveMenu,
}: {
  onClose: () => void;
  setActiveMenu: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const authData = useAuth((s) => s.userDetails);

  return (
    <div className="overflow-y-auto px-48" style={{ height: '59rem' }}>
      <section className="py-48 pb-28">
        <span className="mb-8 block font-medium text-gray-600">Integrations</span>
        <p className="text-sm mb-22 text-gray-600 w-400">
          Manage and view all integrations in this organization
        </p>
      </section>
      <section className="pb-48 border-b flex flex-wrap">
        <AppTile metadata={appMetaData['slack']} setPage={setActiveMenu} />
        <AppTile metadata={appMetaData['github']} setPage={setActiveMenu} />
        <AppTile
          metadata={appMetaData['googleCalendar']}
          setPage={setActiveMenu}
          enabled={authData?.showCalendar}
        />
      </section>
    </div>
  );
};

const AppTile = ({
  metadata,
  setPage,
  button,
  enabled = true,
}: {
  metadata: {
    name: string;
    value: string;
    icon: JSX.Element;
    type: string;
    description: string;
    linkText;
  };
  setPage: React.Dispatch<React.SetStateAction<string>>;
  button?: React.ReactElement;
  enabled?: boolean;
}) =>
  enabled ? (
    <div className="flex w-1/2 mb-32">
      <div>{metadata.icon}</div>
      <div>
        <div className="mb-10">
          <div className="font-medium">{metadata.name}</div>
          <div className="text-sm">{metadata.type}</div>
        </div>
        <p className="text-sm text-gray-500 mb-10">{metadata.description}</p>
        {button || (
          <button
            onClick={() => setPage(metadata.value)}
            className="text-sm text-primary-500 font-medium"
          >
            {metadata.linkText}
          </button>
        )}
      </div>
    </div>
  ) : (
    <div />
  );
